import React from 'react'

export const About=()=> {
  return (
    <div id='About'>
        <h1 className='font-bold text-center mt-20 text-3xl custom-h1 h2-color'>About us</h1>
        <p className='font-bold text-center mt-8 custom-p text-2xl'>Nous croyons en la puissance de la nourriture pour transformer la santé et le bien-être.<br/> Chez nous, chaque bouchée est une invitation à une vie plus saine et plus épanouie.<br/> Nous nous engageons à vous offrir des aliments de qualité, préparés avec soin et conçus pour nourrir<br/> votre corps de la meilleure manière qui soit.<br/>

         Notre mission est simple : rendre la nutrition délicieuse et accessible à tous.<br/> Nous sélectionnons attentivement chaque ingrédient pour garantir des produits de qualité supérieure,<br/> des superaliments riches en nutriments aux délices naturels et équilibrés.<br/>

         Notre équipe est passionnée par la création d'une communauté axée sur la santé et le bien-être.<br/> Nous croyons en l'éducation nutritionnelle et nous nous engageons à vous fournir les connaissances<br/> et les ressources nécessaires pour prendre des décisions éclairées concernant votre alimentation.</p>
    </div>
  )
}
